import React, { useState } from 'react';
import { withRouter } from 'react-router';
import isEmpty from 'lodash/isEmpty';

import { findFlowNodeIndex } from '../utils/flows.utils';
import { FlowDashboardView } from '../components/flow-dashboard/FlowDashboard.view';
import { LoadingPanel } from 'Common/LoadingPanel';

import type { FlowInputOutput } from '../types/flows.types';

const FlowDashboardPageBase: React.FC<{
  flow: FlowInputOutput[];
  entities: unknown[];
  subId: string;
  router: { push: (path: string) => void };
}> = ({ flow, entities, subId, router }) => {
  const [selectedIdx, setSelectedIdx] = useState(0);

  const handleNodeClick = (type: string, id: string) => {
    const realId = id.includes('::loop') ? id.split('::loop')[0] : id;
    router.push(`/subscription/${subId}/${type}s/${type}/${realId}/overview`);
  };

  const handleNodeHover = (idOrParams: string | { node: string }) => {
    setSelectedIdx(findFlowNodeIndex(idOrParams, flow));
  };

  if (isEmpty(flow)) {
    return <LoadingPanel />;
  }

  return (
    <FlowDashboardView
      flow={flow}
      entities={entities}
      subId={subId}
      selectedIdx={selectedIdx}
      onGotoNode={handleNodeClick}
      onHoverNode={handleNodeHover}
    />
  );
};

export const FlowDashboardPage = withRouter(FlowDashboardPageBase);
